import { Helmet } from 'react-helmet';

// Заголовок и описание страницы (вложенный Helmet перекрывает значения по умолчанию из App)
const PageMeta = ({ title, description }) => (
  <Helmet>
    <title>{title}</title>
    <meta property='og:title' content={title} />
    {description && <meta name='description' content={description} />}
    {description && <meta property='og:description' content={description} />}
  </Helmet>
);

export default PageMeta;
